import { reactive } from "@vue/composition-api";

export const enum WeightQuantityPriceStatus {
  actual = "actual",
  estimated = "estimated",
}

const prettifiedWeightQuantityPriceStatus = {
  actual: "Actual",
  estimated: "Estimated",
};

export const prettifyWeightQuantityPriceStatus = (
  s: WeightQuantityPriceStatus,
) => {
  return prettifiedWeightQuantityPriceStatus[s];
};

export function buildFormWeightQuantityPriceStatus() {
  const defaultSellPriceStatuses = reactive<WeightQuantityPriceStatus[]>([]);
  const weightDefaultSellPriceStatuses = reactive<WeightQuantityPriceStatus[]>(
    [],
  );

  const purchasePriceStatuses = reactive<WeightQuantityPriceStatus[]>([]);
  const weightPurchasePriceStatuses = reactive<WeightQuantityPriceStatus[]>([]);

  const weightStatuses = reactive<WeightQuantityPriceStatus[]>([]);
  const quantityStatuses = reactive<WeightQuantityPriceStatus[]>([]);

  const loadWeightQuantityPriceStatusesIntoForm = (
    statuses: WeightQuantityPriceStatus[],
  ) => {
    statuses.push(
      WeightQuantityPriceStatus.actual,
      WeightQuantityPriceStatus.estimated,
    );
  };

  return {
    loadWeightQuantityPriceStatusesIntoForm,
    defaultSellPriceStatuses,
    weightDefaultSellPriceStatuses,

    purchasePriceStatuses,
    weightPurchasePriceStatuses,

    weightStatuses,
    quantityStatuses,
  };
}
